import React from 'react';

import { ColorScheme } from '~/design-tokens/themes/themes';

import * as S from './HeaderLogotype.styles';

export interface HeaderLogotypeProps {
  colorScheme?: ColorScheme;
}

export const HeaderLogotype = ({
  colorScheme = ColorScheme.Dark,
  ...rest
}: HeaderLogotypeProps) => {
  const logoSrc = `/app/static/images/brand/logo-${colorScheme}.svg`;
  const logoMiniSrc = `/app/static/images/brand/logo-v2-mini-dark.svg`;

  return (
    <S.HeaderLogotypeRoot {...rest}>
      <S.Logo src={logoSrc} />
      <S.LogoMini src={logoMiniSrc} height={20} width={30} />
    </S.HeaderLogotypeRoot>
  );
};
